<template>
  <div v-if="showMitError">
    <div class="header">
      <a :href="globalConfig.kkLogoLink">
        <img
          :src="
            siteType.GetSiteType() == siteType.SITE_TYPE_NUTS
              ? '/static/img/register/logo.svg'
              : '/static/img/register/KKBrand_Logo.png'
          "
        />
      </a>
    </div>
    <div>
      <div class="container">
        <div class="detail_section">
          <div class="detail_title">
            <p>{{ $t(tips) }}</p>
          </div>
          <div class="email_icon">
            <img
              :src="
                siteType.GetSiteType() == siteType.SITE_TYPE_NUTS
                  ? '/static/img/register/email/status/email_unverified_nuts.png'
                  : '/static/img/register/email/status/email_unverified.png'
              "
            />
          </div>
          <div class="detail_content">
            <div class="description">
              <p @click="toHome">
                {{ $t(description) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import siteType from "../../configs/siteType";
import { switchLanguage } from "@/utils/switchLang";
import { reportMitCallbackData } from "@/api/official";
export default {
  data() {
    return {
      showMitError: false,
      tips: "register.LAB_EMAIL_FAILED",
      description: "register.LAB_EMAIL_EXPIRED_2",
      siteType,
      tipsMap: {
        default: "register.LAB_EMAIL_FAILED",
        "User cancelled": "register.LAB_MIT_CANCEL",
      },
      registerParams: {},
    };
  },
  created() {
    let registerParams = localStorage.getItem("registerParams");
    this.registerParams = JSON.parse(registerParams);
    console.log("registerParams");
    console.log(this.registerParams);
    let { data = "" } = this.$route.query;
    // 将data进行base64反解码
    if (data.length) {
      let decodedData = atob(data);
      // 将解码后的数据进行JSON.parse解析
      let parsedData = JSON.parse(decodedData);
      console.log(parsedData);

      if (parsedData.error_description) {
        // mit认证错误
        this.showMitError = true;
        this.tips =
          this.tipsMap[parsedData.error_description] || this.tipsMap.default;
      } else {
        // mit认证成功, 跳转到邮箱提示页
        let callbackQuery = localStorage.getItem("mit_callback_query");
        localStorage.removeItem("mit_callback_query");
        this.$router.push({ name: "registerEmail", query: callbackQuery.length ? JSON.parse(callbackQuery) : {} });
      }
      reportMitCallbackData({
        ...this.$route.query,
        // 将email_verification_data进行base64编码
        
        email_verification_data: btoa(JSON.stringify({
          username: this.registerParams.username,
          lang: switchLanguage(),
          token: localStorage.getItem("registerToken"),
        })),
      });
    } else {
      // 没参数情况下显示错误信息
      this.showMitError = true;
    }
  },
  methods: {
    toHome() {
        console.log(this.registerParams.invitecode)
      this.$router.push(`/${this.registerParams.invitecode || ""}`);
    },
  },
};
</script>

<style lang="less">
body,
#default-layout {
  background-color: #151515;
  height: 100%;
}
html,
body,
#default-layout {
  height: 100%;
}
</style>
<style lang="less" scoped>
.header {
  height: 70px;
  background-color: #000000;
  img {
    position: absolute;
    left: 50px;
    top: 15px;
    width: 170px;
    height: auto;
  }
}
.container {
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  .detail_section {
    margin-top: 250px;
    .detail_title {
      p {
        font-size: 32px;
        color: #ffffff;
        text-align: center;
        margin-top: 130px;
      }
    }
    .email_icon {
      text-align: center;
      img {
        width: 100%;
        height: 400px;
        max-width: 400px;
        margin-top: 32px;
      }
    }
    .detail_content {
      margin: 0 50px;
      .description {
        p {
          font-size: 24px;
          color: #ffffff;
          text-align: center;
          margin: 32px 50px 0 50px;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
